import { useContext } from "react";

import { DirectDocumentBudgetContext } from "./DirectDocumentBudgetContext";
import type { DirectDocumentBudget } from "./useDirectDocumentBudget";

/**
 * The budget when one is being tracked, `null` when it is not.
 *
 * Both pickers also render outside the composer — `InputGateModal` mounts them
 * for the workflow input gate — where no conversation and no budget exist.
 * There the pickers show no limit UI and apply no gate, which is correct: the
 * gate is a convenience, and the server seams remain the enforcement boundary
 * either way.
 */
export function useOptionalDirectDocumentBudget(): DirectDocumentBudget | null {
    return useContext(DirectDocumentBudgetContext);
}
